module.exports = __webpack_public_path__ + "images/phone-c7095665b6a67b786b90e2b9b7e87250.png";


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Mockup/phone.png
// module id = 9vjM
// module chunks = 0